import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '足球', href: '/category/football' },
  { label: '篮球', href: '/category/basketball' },
  { label: '网球', href: '/category/tennis' },
  { label: '电竞', href: '/category/esports' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-basketball-line text-xl text-white"></i>
          </div>
          <span className="font-heading text-xl font-bold text-foreground-950 whitespace-nowrap">
            好博体育
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap ${
                location.pathname === link.href
                  ? 'bg-primary-500 text-white'
                  : 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="px-5 py-2 text-sm font-medium text-primary-600 border border-primary-300 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            注册
          </Link>
          <Link
            to="/about"
            className="px-5 py-2 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            登录
          </Link>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                  location.pathname === link.href
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-3 border-t border-background-200/70 mt-2">
              <Link
                to="/about"
                className="flex-1 text-center px-5 py-2.5 text-sm font-medium text-primary-600 border border-primary-300 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                注册
              </Link>
              <Link
                to="/about"
                className="flex-1 text-center px-5 py-2.5 text-sm font-medium bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                登录
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}